export const getLastPart = () => {
  const path = window.location.pathname.split('/');
  return path[path.length - 1];
};

export const getBasename = () => {
  // remove trailing slash
  let pathName = window.location.pathname;
  if (pathName.endsWith('/')) {
    pathName = pathName.slice(0, -1);
  }

  const pathArray = pathName.split('/');

  pathArray.forEach((p, i) => !p && delete pathArray[i]);
  if (pathArray.length > 1) {
    pathArray.pop();
  }
  return pathArray.join('/');
};

export const getUrlPaths = (path: string = window.location.pathname) => {
  return path.replace(/^\/|\/$/g, '').split('/');
};
